import { FC, useState } from 'react';

import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';

import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';

import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
} from 'containers/data-structure';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import moment from 'moment';
import { DATE_FORMAT } from 'constants/global';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

interface AudienceProps {
  intl: IntlShape;
  info: any;
  listings: any;
  setCivilProceedingInfo: Function;
  stakeholders?: any;
  setIsUpdated?: Function;
  lossDate: string;
  readOnly?: boolean;
}
const Audience: FC<AudienceProps> = props => {
  const { circonscription, jurisdictionDegreeId, hearingDate } = props.info;
  const [updatedCivilProceedingInfo, setUpdatedCivilProceedingInfo] = useState({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });
  /* istanbul ignore next */
  const handleChangeDateHearing = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const hearing = moment(theDate as Date).format(DATE_FORMAT);
    props.setCivilProceedingInfo({
      ...props.info,
      hearingDate: hearing,
    });
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      hearingDate: hearing,
    });
    props.setIsUpdated && props.setIsUpdated(true);
  };
  /* istanbul ignore next */
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      [field]: event.target.value,
    });
    props.setCivilProceedingInfo({
      ...props.info,
      [field]: event.target.value,
    });
    props.setIsUpdated && props.setIsUpdated(true);
  };
  return (
    <Grid container>
      <Grid
        container
        item
        direction="row"
        spacing={3}
        style={{ marginTop: 10 }}
      >
        <Grid item xs={4}>
          <TextField
            fullWidth
            id="judgement_number_field"
            label={translate(messages.circomscriptionField, props)}
            value={circonscription}
            onChange={handleChange(
              CIVIL_PROCEEDING_INFORMATIONS_FIELDS.CIRCUMSCRIPTION,
            )}
            disabled={props.readOnly}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl className="input" fullWidth>
            <InputLabel id="idd-label-id">
              {translate(messages.jurisdictionField, props)}
            </InputLabel>
            <Select
              fullWidth
              labelId="idd-label-id"
              value={jurisdictionDegreeId}
              onChange={handleChange(
                CIVIL_PROCEEDING_INFORMATIONS_FIELDS.DEGREE_OF_JURISDICTION,
              )}
              disabled={props.readOnly}
            >
              {get(props.listings, 'jurisdictionDegrees', []).map(
                (element: { id: number; title: string }) => (
                  <MenuItem value={element.id}>{element.title}</MenuItem>
                ),
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              fullWidth
              autoOk
              variant="inline"
              minDate={addDaysToDate(props.lossDate, 1)}
              invalidDateMessage={
                '' // add error
              }
              format="dd/MM/yyyy"
              id="date-picker-inline-victim-date-of-birth"
              label={translate({ ...messages.hearingDateField }, props)}
              className="input"
              name={CIVIL_PROCEEDING_INFORMATIONS_FIELDS.HEARING_DATE}
              value={dateStringToLocalDate(hearingDate)}
              onChange={handleChangeDateHearing}
              disabled={props.readOnly}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default injectIntl(Audience);
